import { useQuery } from "@tanstack/react-query";

import { listIntegrations } from "../api/integrations";

export const useListIntegrations = ({
  organizationId,
  enabled = true,
}: {
  organizationId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryFn: () => listIntegrations({ organizationId }),
    queryKey: ["integrations", organizationId],
    enabled: !!organizationId && enabled,
  });
};
